import React, { lazy, useEffect, useState, useCallback } from 'react';
import './App.scss';
import { useDispatch, useMappedState } from 'redux-react-hook';
import { Auth, API } from "aws-amplify";
/**Routes*/
// import ROUTES from './routes';
import { Router, Route, Switch } from "react-router-dom";
import history from './utils/history';
// import { BusinessHeader, UnAuthHeader, OpenHeader } from './components/Header';
import {  IconButton, Menu, MenuItem, makeStyles } from '@material-ui/core';
import Routes from "./Routes";
import { MenuLateral } from './components/Menu';
import * as UserAction from './store/user/actions';
import { AccountCircle } from '@material-ui/icons';
import ROUTES from './routesConstants';
import {ToastAlert} from './components/Alert'

const App = (props: any) => {
  console.log("Inicio la app")
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setAuthenticated] = useState(false);

  console.log("props AHORA", props)
  // let location = useLocation();
  // console.log("C amigos123",location)

  const [childProps, setChildProps] = useState({
    isAuthenticated: false,
    isRegisterBusiness: true
  });
  const [codTercero, setTercero] = useState('');
  const dispatch = useDispatch();
  const mapState = useCallback(
    state => ({
      typeHeader: state.header.typeHeader,
      payload: state.header.typeHeader,
      isAuthenticatedRedux: state.user.isAuthenticated,
      userData: state.user.user,
      alert:state.alert.alert
    }),
    []
  );
  const { alert,userData, isAuthenticatedRedux, typeHeader, payload = null } = useMappedState(mapState);
  console.log("alert",alert)
  const changeRoute = (route: string) => {
    console.log("Esto es algo cool ", route)
    setAnchorEl(null);
    history.push(route);
  };
  const obtenerDatosDelTerceroLogueadoSimulacion = async (res:any) => {
    // console.log("Esto es importante");

    // return {
    //   isRegisterBusiness: true,
    //   cod_negocio: 66,
    //   cod_admin: 153,
    //   businessName: 'EMPRESA DEMO'

    // }
    console.log("[obtenerDatosDelTerceroLogueadoSimulacion]",childProps.isAuthenticated)
    // if(childProps.isAuthenticated){
      const objTercero={
        "body":{
          "request":{
            "payload": {
              "codroltercero" : parseInt(res.idToken.payload['custom:codroltercero'])
            }
          }
        }
      }
      console.log("objTercero",objTercero)
      const tercero = await API.post('delivery', '/common/obtenerTercero', objTercero)
      console.log("[tercero]",tercero)
      console.log("res.idToken.payload",res.idToken.payload)
      let isRegisterBusiness;
      if(res.idToken.payload['cognito:groups'].includes('APP_TIENDA')){
        isRegisterBusiness=true
      }else{
        isRegisterBusiness=tercero.payload[0].cod_negocio?true:false
      }
      let routes;
      if(res.idToken.payload.profile=='TIENDA'||res.idToken.payload.profile=='ADMIN_TIENDA'){
        routes=[
          {
            title: 'Catálogo de productos',
            path: ROUTES.OLD_PRODUCTS
          },
          {
            title: 'Listado de pedidos en curso',
            path: ROUTES.OLD_GESTION_PEDIDOS
          },
          {
            title: 'Danos tu Feedback',
          },
        ]
      }else{
        routes=[
          {
            title: 'Administración de la empresa',
            path: ROUTES.OLD_BUSINESS_REGISTER
          },
          {
            title: 'Administración de colaboradores',
            path: ROUTES.OLD_REGISTRO_EMPLEADOS
          },
          {
            title: 'Listado de pedidos en curso',
            path: ROUTES.OLD_GESTION_PEDIDOS
          },
          {
            title: 'Catálogo de productos',
            path: ROUTES.OLD_PRODUCTS
          },
          {
            title: 'Danos tu Feedback',
          },
        ]
      }
      console.log("rutas",routes)
      return {
          isRegisterBusiness:isRegisterBusiness ,
          cod_negocio: tercero.payload[0].cod_negocio,
          cod_tercero: parseInt(res.idToken.payload['custom:codroltercero']),
          roles:res.idToken.payload['cognito:groups'],
          routes:routes
        };
    // }
  }

  const logueoMethods = async () => {
    console.log("Esto es algo isAuthenticatedRedux", isAuthenticatedRedux)
    let isRegisterBusinessAux = false;
    if (isAuthenticatedRedux) {
      try {

        let res: any = await Auth.currentSession()
        const { idToken = {} } = res;
        const { payload } = idToken;
        const user = payload;
        setAuthenticated(true)
        console.log("user", user)
        console.log("tkn", idToken.jwtToken)
        const userParameters = await obtenerDatosDelTerceroLogueadoSimulacion(res);

        console.log("[userParameters]",userParameters)
        console.log("ROL TERCERO",res.idToken.payload['custom:codroltercero'])
        console.log("RESTO",res)
        
        dispatch(UserAction.setAuthenticated(true));
        dispatch(UserAction.setUser(userParameters))

        // if(userParameters.cod_negocio){
        //   isRegisterBusinessAux=true;
        // }
        isRegisterBusinessAux=userParameters.isRegisterBusiness;
      } catch (e) {

        console.log("Hubo un error", e)
        isRegisterBusinessAux = false;
      }



    }
    setChildProps({
      isAuthenticated: isAuthenticatedRedux,
      isRegisterBusiness: isRegisterBusinessAux
      // isRegisterBusiness: true
    })

  }
  
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    console.log("PROFILE")
    setAnchorEl(null);
  };

  const renderMenu = (
    <Menu className="Menu"
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        id="primary-search-account-menu"
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMenuOpen}
        onClose={handleMenuClose}
        >
        <MenuItem onClick={()=>changeRoute(ROUTES.UPDATE_USER)}>Actualizar mis Datos</MenuItem>
        <MenuItem onClick={()=>changeRoute(ROUTES.UPDATE_PASSWORD)}>Actualizar Contraseña</MenuItem>
    </Menu>
  );

  const useStyles = makeStyles((theme) => ({
    deleteIcon1: {
      '& svg': {
        fontSize: 70
      }
    }
  }));

  const classes = useStyles();
  
  useEffect(() => {
    logueoMethods();
  }, [isAuthenticatedRedux]);

  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {

      console.log("Esto es el userData123", userData);
      setChildProps({
        isAuthenticated: isAuthenticatedRedux,
        isRegisterBusiness: userData.isRegisterBusiness
        // isRegisterBusiness: true
      })
    }
  }, [userData]);


  return (
    <div className="page">

      <div className="body">
        {
          childProps.isAuthenticated ?
            (<div className="menu">
              <MenuLateral />
            </div>)

            : null
        }
        <div className={`page-content ${childProps.isAuthenticated ? 'shared' : 'full'}`}>
          {/* <ToastAlert
            open={true}
            severity='success'
            alertMessage='Mensaje exitoso'
          /> */}
          {userData.isRegisterBusiness?
          (
            <div className="profile">
              <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls="primary-search-account-menu"
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
              className={classes.deleteIcon1}
              >
                  <AccountCircle />
              </IconButton>
              {renderMenu}
            </div>
          )
            :null
          }
          
          <Router history={history}>
            <React.Suspense fallback="">
            <Routes childProps={childProps} />
              {/* <Routes child={childProps} isAuthenticated={isAuthenticatedRedux}/> */}
            </React.Suspense>
          </Router>
        </div>
      </div>
      <ToastAlert
        open={alert.open}
        severity={alert.severity}
        alertMessage={alert.alertMessage}
      />
    </div>



  );
}

export default App;
